
import React from 'react';
import AppShell from '@/app/shell/AppShell';

const Layout: React.FC = () => {
  return <AppShell />;
};

export default Layout;
